import { render } from "./ReferralMerchantFeesTable.vue?vue&type=template&id=77c6c4e8&ts=true"
import script from "./ReferralMerchantFeesTable.vue?vue&type=script&lang=ts"
export * from "./ReferralMerchantFeesTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__